module.exports = __webpack_public_path__ + "img/favouritePiece@2x.c4e906c.jpg";